export default "__VITE_ASSET__DzBfjhzo__"